module.exports = __webpack_public_path__ + "02_mole.a44200ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer3/02_mole.png
// module id = iBkG
// module chunks = 0